import React from 'react';
import './styles.scss';
import { Config } from '@/types';
import { useConfigStore } from '@/hooks';
import { useCustomComponent } from '@/hooks';
import clsx from 'clsx';

export interface TextProps {
  size: keyof Config.Theme['typography']['fontSize'];
  center?: boolean;
  color?: 'themePrimary' | keyof Config.Theme['colors']['text'];
  weight?: keyof Config.Theme['typography']['fontWeight'];
  lineHeight?: keyof Config.Theme['typography']['lineHeight'];
  family?: keyof Config.Theme['typography']['fontFamily'];
  children: React.ReactNode;
}

const TextComponent: React.FC<TextProps> = ({
  children,
  size,
  center = false,
  color = 'primary',
  weight = 'normal',
  lineHeight = 'normal',
  family = 'primary',
}) => {
  const {
    theme: { typography, colors },
  } = useConfigStore();

  const textColor =
    color === 'themePrimary' ? colors.primary : colors.text[color];

  return (
    <span
      className={clsx('peptalk-text', center && 'text-center')}
      style={{
        fontSize: typography.fontSize[size],
        color: textColor,
        fontWeight: typography.fontWeight[weight],
        lineHeight: typography.lineHeight[lineHeight],
        fontFamily: typography.fontFamily[family],
      }}
    >
      {children}
    </span>
  );
};

export const Text: React.FC<TextProps> = (props: TextProps) => {
  const Component = useCustomComponent({
    componentName: 'Text',
    Component: TextComponent,
  });

  return <Component {...props} />;
};
